import BusinessContainer from "../../common/BusinessContainer";
import LoadingScreen from "../../common/LoadingScreen";
import styles from "../css/SlotPurchaseScreen.module.css";
import { Page, PageHeader } from "../../../components/layout/Page";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { privacyPolicyUrl, termsOfUseUrl } from "../../common/contants";
import {
  deliverSlot,
  requestPurchase,
  verifyPurchase,
} from "../service/purchase";
import {
  PurchaseProduct,
  product_slot_10000,
  product_slot_20000,
  product_slot_5000,
} from "../model/products";
import { generateRandomOrderNumber } from "../../common/numbers";
import { getEmailAdress, getUsername } from "../../auth/AuthManager";
import SlotProductView from "./SlotProductView";

export default function SlotPurchaseScreen() {
  const navigate = useNavigate();

  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const termsOfUse = t("TermsOfUse");
  const privacyPolicy = t("PrivacyPolicy");

  function moveToMain() {
    navigate("/");
  }

  function openTermsOfUsePage() {
    window.open(termsOfUseUrl);
  }

  function openPrivacyPolicyPage() {
    window.open(privacyPolicyUrl);
  }

  function successPurchaseAndFinish() {
    alert(t("SlotPurchaseSuccessMessage"));
    navigate("/");
  }

  async function handleOnClickPurchaseButton(product: PurchaseProduct) {
    const paymentID = generateRandomOrderNumber(20);

    if (!(await purchase(paymentID, product))) return;
    if (!(await verifyPurchaseOnServer(paymentID, product))) return;
    if (!(await deliver(paymentID, product))) return;

    successPurchaseAndFinish();
  }

  async function purchase(
    paymentId: string,
    product: PurchaseProduct
  ): Promise<boolean> {
    setIsLoading(true);
    try {
      await requestPurchase(product, {
        paymentId: paymentId!,
        channerKey: "channel-key-ebe6cd18-4395-473b-b5a9-8457f576038a",
        customer: {
          name: getUsername(),
          phone: "010-3871-3553",
          email: await getEmailAdress(),
        },
      });
      setIsLoading(false);
      return true;
    } catch (error) {
      setIsLoading(false);
      return false;
    }
  }

  async function verifyPurchaseOnServer(
    paymentID: string,
    product: PurchaseProduct
  ): Promise<boolean> {
    setIsLoading(true);
    try {
      await verifyPurchase(paymentID, product);
      setIsLoading(false);
      return true;
    } catch (error) {
      if (error instanceof Error) {
        alert(error.message);
      } else {
        alert(error);
      }
      setIsLoading(false);
      return false;
    }
  }

  async function deliver(
    paymentID: string,
    product: PurchaseProduct
  ): Promise<boolean> {
    setIsLoading(true);
    try {
      await deliverSlot(paymentID, product);
      setIsLoading(false);
      return true;
    } catch (error) {
      if (error instanceof Error) {
        alert(error.message);
      } else {
        alert(error);
      }
      setIsLoading(false);
      return false;
    }
  }

  return (
    <>
      <div className={styles.stack}>
        <div className={styles.container}>
          <Page className={styles.page}>
            <PageHeader
              title={t("SlotAddButton")}
              subtitle={t("SlotExtendDetailMessage")}
              onBack={() =>
                (window.history.state?.idx ?? 0) > 0
                  ? navigate(-1)
                  : moveToMain()
              }
              backLabel={t("Back")}
            />
            <div className={styles.productContainer}>
              <SlotProductView
                product={product_slot_5000}
                onClickPurchaseButton={handleOnClickPurchaseButton}
              />
              <SlotProductView
                product={product_slot_10000}
                compareProduct={product_slot_5000}
                isBest
                onClickPurchaseButton={handleOnClickPurchaseButton}
              />
              <SlotProductView
                product={product_slot_20000}
                compareProduct={product_slot_5000}
                onClickPurchaseButton={handleOnClickPurchaseButton}
              />
            </div>

            <span className={styles.desciptionText}>
              <Trans
                i18nKey="PurchaseDescriptionMessage"
                values={{ termsOfUse, privacyPolicy }}
              >
                <span
                  className={styles.highlightText}
                  onClick={() => openTermsOfUsePage()}
                >
                  {termsOfUse}
                </span>
                <span
                  className={styles.highlightText}
                  onClick={() => openPrivacyPolicyPage()}
                >
                  {privacyPolicy}
                </span>
                <span
                  className={styles.highlightText}
                  onClick={() => openTermsOfUsePage()}
                >
                  {termsOfUse}
                </span>
              </Trans>
            </span>
          </Page>
          <BusinessContainer />
        </div>
        {isLoading === true && <LoadingScreen />}
      </div>
    </>
  );
}
